import { Image, View } from "@aws-amplify/ui-react";
import StorageGet from "aws_utils/s3storageget";
import React from "react";
import Modal from "react-modal";

export const DisplayImage = (key: { image_key: "" }) => {
  // console.log("key", key);

  const [url, seturl] = React.useState("");
  const [showdata, setshowdata] = React.useState(false);
  const [currentkey, setcurrentkey] = React.useState("");
  const closeModal = async () => {
    setshowdata(false);
  };

  React.useEffect(() => {
    const getUrl = async (key: { image_key: "" }) => {
      try {
        const get_url = await StorageGet(key.image_key);
        // console.log("Get Url", get_url);
        seturl(`${get_url}`);
        // seturl({...url, get_url})
      } catch (error) {
        console.log("Error", error);
      }
    };
    getUrl(key);
  }, [key]);

  if (key.image_key === "" || url === "") {
    return;
  }

  return (
    <View className={`relative flex w-full items-center justify-center`}>
      <Image
        key={key.image_key}
        src={url}
        alt=""
        position="relative"
        objectFit="contain"
        //  backgroundColor="red"
        width="80%"
        maxHeight="700px"
        //  height=""
        onClick={() => {
          setcurrentkey(url);
          setshowdata(true);
        }}
      />

      <Modal
        isOpen={showdata}
        onRequestClose={closeModal}
        style={{
          overlay: {
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            zIndex: 999,
          },
          content: {
            position: "relative",
            //   display
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            border: "1px solid #ccc",
            height: "auto",
            //   background: 'blue',
            width: "502px",
            //   overflow: 'auto',
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "0px",
          },
        }}
      >
        <View
          display="block"
          position="relative"
          // backgroundColor="pink"
          // width="300px"
          // height="30px"
          // justifyContent="center"
          // backgroundColor="yellow"
          // paddingTop="30px"
        >
          <Image
            alt=""
            src={currentkey}
            position="relative"
            objectFit="cover"
            //  backgroundColor="red"
            width="100%"
            height="100%"
          />
        </View>
      </Modal>
    </View>
  );
};
